import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { SliderComponent } from '@appNeo/pages/plugins/slider/slider.component';
import { IMGMAPA } from './mapa-areas-configuracion';
import { IElementoSlider, ImagenSlider } from '@appNeo/pages/plugins/slider/slider.component';
import { HelpersService } from '@appNeo/neoCore/services/helpers/helpers.service';
import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'neo-mapa-areas',
  templateUrl: './mapa-areas.component.html',
  styleUrls: ['./mapa-areas.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MapaAreasComponent implements OnInit {

  titulo_tit = 'titulo-tit';

  imagesMapa: IElementoSlider[] = [];
  activeLocation: number = 1;
  tamanoTitulo: string = 'h3';
  @ViewChild('sliderArea') sliderArea: SliderComponent;

  constructor(
    private helpersService: HelpersService,
    private edicionSeccionesService: EdicionSeccionesService
  ) {
    this.iniciarPagina();
  }

  ngOnInit(): void { 

  }

  iniciarPagina(){
    if (this.helpersService.hayModulo('edicion')) {
      this.edicionSeccionesService.getContenidoBloquesSubseccion('area-titulo').subscribe(data => {
        data.elementos.forEach((elemento, index) => {
          let indice = (data.multiple) ? index : -1;
          this.titulo_tit = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'titulo-tit', indice);
          return;
        })
      })
      // let areas = ['piscina', 'tirolina', 'paintball', 'multideporte', 'hoverboard', 'cubierta', 'terraza', 'kids'];
      let areas = ['sueloInteractivo', 'paintball', 'multideporte', 'tirolina', 'terraza', 'piscina', 'kids', 'cubierta', 'hoverboard'];
      areas.forEach((area, orden) => {
        this.edicionSeccionesService.getContenidoBloquesSubseccion('area-'+area).subscribe(data => {
          // console.log('Orden y area ', data);
          data.elementos.forEach((elemento, index) => {
            let indice = (data.multiple) ? index : -1;
            let areaImg = this.edicionSeccionesService.getCamposEdicionItem(elemento, area+'-img', indice);
            let areaTit = this.edicionSeccionesService.getCamposEdicionItem(elemento, area+'-tit', indice);
            let areaTxt = this.edicionSeccionesService.getCamposEdicionItem(elemento, area+'-txt', indice);
            this.imagesMapa.push({ 
              media: { src: areaImg['ruta'], alt: '' }, 
              titulo: areaTit, 
              texto: areaTxt,
              orden: orden 
            });
            // console.log(this.imagesMapa);
            this.imagesMapa.sort(function (a, b) { return a.orden > b.orden ? 1 : b.orden > a.orden ? -1 : 0 });


          });
        });
      });

    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.establecerUbicacionActiva(1);
    });
  }

  seleccionarSlide(indice) {
    let indiceSlide = (indice - 1 > 0) ? indice - 1 : 0;
    this.sliderArea?.swiper['swiper']?.slideToLoop(indiceSlide, 1000, true);
  }

  establecerUbicacionActiva(idUbicacion) {
    this.activeLocation = idUbicacion;
    this.seleccionarSlide(idUbicacion);
  }

  transicionSlide(slider) {
    let objeto = Object.assign({}, slider);
    let _indice = objeto.activeIndex;
    if (objeto.activeIndex > this.imagesMapa.length) {
      _indice = _indice - this.imagesMapa.length;
    }
    if (_indice != this.activeLocation) {
      this.activeLocation = _indice;
    }
  }
}
